export default "__VITE_ASSET__CLOcoqrz__"